"use client";

import { Button } from "@masterkey/ui/button";
import { Icons } from "@masterkey/ui/icons";
import { LogOut, Menu, X } from "lucide-react";
import { useState } from "react";

import { useUser } from "@/hooks/useUser";

import { BaseNavbar } from "@/components/base-navbar";
import { NavLink } from "@/components/nav-link";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { UserAvatar } from "@/components/ui/user-avatar";

export const MainNavbar = () => {
  const { user, avatarUrl, handleSignIn, handleSignOut } = useUser();

  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const toggleMenu = () => setIsMenuOpen(!isMenuOpen);

  const mobileMenuContent = (
    <div className="mt-4">
      {user ? (
        <div className="flex flex-col gap-3">
          <button
            onClick={handleSignOut}
            className="rounded-full text-left font-bold"
            type="button"
          >
            <LogOut size={16} className="mr-2 inline" />
            Logout
          </button>
        </div>
      ) : (
        <div className="flex flex-col">
          <NavLink href="/login" className="font-bold">
            Sign In
          </NavLink>
        </div>
      )}
    </div>
  );

  return (
    <BaseNavbar
      className="relative bg-chalk md:shadow-sm"
      mobileMenuContent={isMenuOpen && mobileMenuContent}
    >
      <div className="hidden h-full items-center gap-10 md:flex">
        {user ? (
          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <Button variant="ghost" className="relative h-8 w-8 rounded-full">
                <UserAvatar avatarUrl={avatarUrl} />
              </Button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end">
              <DropdownMenuItem onClick={handleSignOut}>
                <Icons.SignOut className="mr-2 h-4 w-4" />
                <span>Log out</span>
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        ) : (
          <Button onClick={handleSignIn} className="rounded-full font-bold">
            Sign In
          </Button>
        )}
      </div>

      <button className="md:hidden" onClick={toggleMenu} type="button">
        {isMenuOpen ? <X size={24} /> : <Menu size={24} />}
      </button>
    </BaseNavbar>
  );
};
